import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";
import Slide from "react-reveal/Slide";

type IPagerHeaderComp = {
  title?: string;
  subTitle?: string;
};

export const PagerHeaderComp: React.FC<IPagerHeaderComp> = ({
  title,
  subTitle,
}) => {
  return (
    <Slide up>
      {/* Header Title */}
      <header className="relative text-white px-6">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/site/banner1.jpg)`,
          }}
        />
        {/* Overlay color */}
        <div className="absolute inset-0 bg-gradient-to-r from-red-700 to-orange-900 opacity-90" />

        {/* Content */}
        <div className="relative z-10">
          <div className=" text-white text-center py-24 fontJostRegular">
            <div className="container mx-auto px-4">
              <h2 className="text-4xl font-bold mb-2 fontJostBold">{title}</h2>
              <p className="text-lg font-medium">{subTitle}</p>
            </div>
          </div>
        </div>
      </header>
      {/* Header Title */}
    </Slide>
  );
};

export default PagerHeaderComp;
